// src/curated/tripCovers.js
// Real destination photos for curated trips (files live in public/trips/).
// A trip's own `cover` wins; otherwise we match a destination keyword in the slug or title.
// Add a photo: drop the .jpg in public/trips/ and add a line below.
const COVERS = [
    { keys: ["rishikesh", "haridwar"], src: "/trips/rishikesh.jpg" },
    { keys: ["manali", "solang", "kullu"], src: "/trips/manali.jpg" },
    { keys: ["munnar"], src: "/trips/munnar.jpg" },
    { keys: ["ooty", "nilgiri", "coonoor", "kotagiri"], src: "/trips/ooty.jpg" },
    { keys: ["coorg", "kodagu", "madikeri"], src: "/trips/coorg.jpg" },
];

export function getTripCover(trip) {
    if (!trip) return null;
    if (trip.cover) return trip.cover;
    const hay = `${trip.slug || ""} ${trip.title || ""} ${trip.entry?.city || ""}`.toLowerCase();
    const hit = COVERS.find((c) => c.keys.some((k) => hay.includes(k)));
    return hit ? hit.src : null;
}
